module.exports = [{"tabName":"HOME","children":[],"url":"/ter/home","target":"none"},{"tabName":"产品中心","children":[],"url":"/ter/produce","target":"none"},{"tabName":"微服务","children":[],"url":"/ter/server","target":"none"},{"tabName":"关于我们","children":[],"url":"/ter/aboutUs","target":"none"},{"tabName":"友情链接","url":"#","target":"none","children":[{"tabName":"福音影视","url":"https://www.ifuyin.tv/","target":"_blank"},{"tabName":"赞美诗网","url":"http://www.zanmeishi.com/","target":"_blank"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/json/ter/header.json
// module id = oUQP
// module chunks = 0